import SlotSymbol from '@/app/(home)/components/slot-symbol';
import FullWidthSection from '@/components/full-width-section';
import SlotReel from '@/components/slot-reel';
import { useLatestStatistic } from '@/services/query/statistics.query';

const SimulationSection = () => {
  const { data: statisticEntity } = useLatestStatistic();
  const time =
    statisticEntity?.data?.averagePracticeTime !== undefined &&
    statisticEntity?.data?.averagePracticeTime !== null
      ? statisticEntity.data.averagePracticeTime
      : 14;
  const passRate =
    statisticEntity?.data?.passRate !== undefined &&
    statisticEntity?.data?.passRate !== null
      ? statisticEntity.data.passRate.toFixed(2)
      : 95;

  return (
    <FullWidthSection className="bg-bg-grayblue">
      <section className="desktop:pt-25 w-full px-6 pt-20 text-center">
        <h2 className="text-level-2 typo-32 desktop:typo-50 desktop:leading-snug leading-snug font-semibold">
          <span className="font-black">운전시뮬레이션</span>으로
          <br />
          <span className="font-black">
            정말{' '}
            <span className="after:bg-main-yellow relative inline-block after:absolute after:bottom-[0.24em] after:left-0 after:-z-10 after:h-3 after:w-full">
              운전면허취득
            </span>
          </span>
          이{' '}
          <span className="desktop:hidden">
            <br />
          </span>
          가능하냐구요?
        </h2>
        <div className="text-level-6 typo-18 desktop:mt-13 desktop:typo-24 desktop:px-6 desktop:py-3 mt-8 inline-block rounded-full bg-white px-5 py-2 font-bold">
          평균 연습시간
        </div>
        <div className="desktop:mt-12 desktop:space-x-6 mt-7 flex items-center justify-center space-x-3">
          {time
            .toString()
            .split('')
            .map((char, idx) =>
              char === ',' ? (
                // 콤마: 숫자 블록과 같은 라인 끝에 맞춤
                <span
                  key={idx}
                  className="text-level-2 typo-48 mr-1 -ml-1 font-extrabold"
                >
                  ,
                </span>
              ) : (
                // 숫자 블록
                <div key={idx}>
                  {/**웹 */}
                  <div className="text-main-yellow bg-level-2 desktop:flex hidden h-[148px] w-[132px] items-center justify-center rounded-md text-[100px] font-extrabold">
                    <SlotReel
                      key={idx}
                      num={Number(char)}
                      children={SlotSymbol}
                      height={148}
                      width={132}
                    />
                  </div>
                  {/**모바일 */}
                  <div className="text-main-yellow bg-level-2 typo-48 desktop:hidden flex h-[66px] w-[54px] items-center justify-center rounded-md font-bold">
                    <SlotReel
                      key={idx}
                      num={Number(char)}
                      children={SlotSymbol}
                      height={66}
                      width={54}
                    />
                  </div>
                </div>
              ),
            )}
          <span className="text-level-2 typo-18 desktop:typo-50 desktop:font-black desktop:ml-2 font-extrabold">
            시간
          </span>
        </div>
        {/**웹 */}
        <p className="text-level-2 typo-28 desktop:block mt-11 hidden leading-normal font-semibold">
          합격무제한반 수강생 기준, 평균 {time}시간 연습 후<br />
          {passRate}% 이상의 합격률로 면허를 취득하고 있습니다.
        </p>
        {/**모바일 */}
        <p className="text-level-2 typo-18 desktop:hidden mt-10 leading-normal font-semibold">
          합격무제한반 수강생 기준,
          <br /> 평균 {time}시간 연습 후 {passRate}% 이상의 합격률로
          <br /> 면허를 취득하고 있습니다.
        </p>
      </section>
    </FullWidthSection>
  );
};

export default SimulationSection;
